// extracted by mini-css-extract-plugin
export default {"list":"styles-module__list__src-labstep-web-components-EntitySnapshot-List-_hUgJo","selected":"styles-module__selected__src-labstep-web-components-EntitySnapshot-List-_Vybrx"};